import BasicLayout from '@/layouts/basic-layout'

const prefix = 'accounts-flow-statement-'
export default {
  path: '/report-center/accounts-flow-statement',
  redirect: {name: `${prefix}index`},
  component: BasicLayout,
  children: [
    {
      path: 'index',
      name: `${prefix}index`,
      meta: {title: '流水报表'},
      component: () => import('@/pages/report-center/accounts-flow-statement/index')
    },
    {
      path: 'detail-edit/:id',
      name: `${prefix}edit`,
      auth: ['hidden'],
      meta: {title: '流水报表编辑'},
      component: () => import('@/pages/report-center/accounts-flow-statement/detail-edit')
    },
    {
      path: 'detail-view/:id',
      name: `${prefix}view`,
      auth: ['hidden'],
      meta: {title: '流水报表详情'},
      component: () => import('@/pages/report-center/accounts-flow-statement/detail-view')
    }
  ]
}
